export default "/images/framework/Bell.e3553266.svg?e3553266";